<template>
  <v-app  v-bind:style="stylePagina">
    <v-main  v-bind:style="stylePagina">
      <v-container fluid class="pa-0">

        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card>
            <v-card-title class="text-h5">
              Ingresaron tus Datos!
            </v-card-title>
            <v-card-text class="text-h6">¡Listo! ¡Tu código QR está en tu correo!</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <section>
          <v-img src="@/assets/jw/formulariojw.jpg"></v-img>
        </section>
        <section >

          <v-row  justify="center" v-bind:style="styleMain" align="center">
            <v-col  cols="12" sm="12" md="6" lg="6">
              <v-row justify="center" justify-lg="end" justify-md="end">
                <v-col cols="10" lg="6" md="6" >
                <v-img   src="@/assets/jw/pasosjw.png"></v-img>
                </v-col>
              </v-row>
            </v-col>
            <v-col  cols="12" sm="12" md="6" lg="6" >

                <v-row   v-bind:style="styleForm" class="pa-12" >
                  <v-col cols="12" >
                    Completa el formulario a continuación:
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="ma-0  pa-1">
                    <v-text-field outlined  v-bind:style="styleComponent" v-model="editedItem.nombre" :label="$t('formularios.nombres')"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="ma-0 pa-1">
                    <v-text-field outlined v-bind:style="styleComponent" v-model="editedItem.apellidoPaterno" :label="$t('formularios.ApPaterno')"></v-text-field>
                  </v-col>
                  <v-col cols="12"  class="ma-0 pa-1">
                    <v-text-field outlined v-bind:style="styleComponent" v-model="editedItem.email" :label="labelEmail" :rules="emailRules" required></v-text-field>
                  </v-col>
                  <v-col cols="12"  class="ma-0 pa-1">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="editedItem.fechaNacimiento"
                                    outlined v-bind:style="styleComponent"  label="Fecha de Nacimiento"
                                    hint="YYYY-MM-DD" persistent-hint
                                    @blur="date = editedItem.fechaNacimiento"
                                    @change="verEdad"
                                    v-on="on"
                                    ></v-text-field></template>
                    <v-date-picker
                        v-model="date"
                        no-title
                        min="1930-01-01"
                        :max="maximafecha"
                        @input="menu1 = false"
                        @change="editedItem.fechaNacimiento = date"
                    ></v-date-picker>
                  </v-menu>
                  </v-col>
                  <v-col  cols="12"  class="ma-0 pa-1">
                    <v-autocomplete  outlined  v-model="editedItem.sexo" :items="sexos" item-value="idSexo" item-text="Sexo"  persistent-hint
                                     return-object
                                     single-line :label="labelSexo"></v-autocomplete>
                  </v-col>
                  <v-col  cols="12" class="ma-0 pa-1">
                    <v-autocomplete class="ma-0" outlined  v-model="editedItem.distrito" :items="distritos" item-value="distritoId" item-text="distrito" persistent-hint
                                     return-object
                                     single-line :label="labelDistrito"></v-autocomplete>
                  </v-col>

                  <v-col cols="12" class="ma-0 pa-1" >
                    <v-text-field class="ma-0" outlined v-bind:style="styleComponent" v-model="editedItem.dni" :label="labelDNI" required></v-text-field>
                  </v-col>

                  <v-col  cols="12" sm="12" md="12" class="mt-0 pa-1">

                    <v-checkbox
                        v-model="editedItem.aceptoCondicion"
                        :rules="[v => !!v || 'Debes aceptar para continuar']"
                        :label="condiciones"
                        required
                        style="color: #1E3D90 !important;"
                        color="#1E3D90"
                        class="ma-0"
                    ></v-checkbox>  </v-col>

                  <v-col  cols="12" sm="12" md="12" class="mt-0 pa-1">

                    <v-checkbox
                        v-model="aceptotermino"
                        class="ma-0"
                        :rules="[v => !!v || 'Debes aceptar para continuar']"
                        required
                        style="color: #1E3D90 !important;"
                        color="#1E3D90"
                    >

                        <template v-slot:label>
                          <div  >
                            Acepto los
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <a
                                    @click.stop
                                    v-on="on"
                                    href="https://tunaydocs.s3.amazonaws.com/BASES+PROMOCI%C3%93N+TINDER+BLONDE.docx.pdf" target="_blank">Términos y Condiciones</a>
                              </template>
                              Abrir en nueva ventana.
                            </v-tooltip>
                            de la Promoción.<br/>
                            Acepto la
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <a
                                    @click.stop
                                    v-on="on"
                                    href="https://footer.diageohorizon.com/dfs/assets/policies.diageohorizon.com/PrivacyPolicy_es.html" target="_blank">Política de Cookies</a>
                              </template>
                              Abrir en nueva ventana.
                            </v-tooltip>
                            y autorizo el tratamiento de mi información personal para generar mi Código QR
                          </div>
                        </template>


                    </v-checkbox>  </v-col>

                  <v-col cols="12">
                    <v-alert
                        :value="alerterror"
                        color="red"
                        dark
                        dismissible
                        border="top"
                        transition="scale-transition"
                    >
                      {{error}}
                    </v-alert>
                    <v-btn  style="background-color: #1E3D90 !important; width: 100%; color: white;"  @click="save">PARTICIPAR</v-btn>
                  </v-col>
                </v-row>
            </v-col>
          </v-row>

        </section>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/infinity.gif"

          />
        </v-overlay>
        <v-footer

        color="white"

        >
<v-img  src="@/assets/jw/footerjw.png"></v-img>
        </v-footer>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "johnniewalkerblonde",
  title: "Johhnie Walker Blonde",
  data () {
    return {
      tagevento:'',
      alertnuevo: false,
      campoapmaterno: false,
      maximafecha: null,
      tiposdoc: [{id:0,tipoDocumento:"Escoger Tipo de Documento",pais:{id:0,activo:false,codigo:'NN',pais:'NO PAIS',importancia: 0}}, {id:5, tipoDocumento:"DNI",pais:{id:46,activo:false,codigo:'cl',importancia:4,pais:'Chile'}}, {id:6, tipoDocumento:"CI",pais:{id:46,activo:false,codigo:'cl',importancia:4,pais:'Chile'}}, {id:7, tipoDocumento:"RUT",pais:{id:46,activo:false,codigo:'cl',importancia:4,pais:'Chile'}}, {id:8, tipoDocumento:"RUN",pais:{id:46,activo:false,codigo:'cl',importancia:4,pais:'Chile'}}, {id:9, tipoDocumento:"Pasaporte",pais:{id:46,activo:false,codigo:'cl',importancia:4,pais:'Chile'}}],
      sexos: [{id:0,Sexo:"Escoger Sexo"}, {id:1, Sexo:"Masculino"}, {id:2, Sexo:"Femenino"}, {id:3, Sexo:"Prefiero No Decirlo"}],
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      alerterror: false,
      error:'',
      distritos:[],
      aceptotermino:false,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      paises:[],
      rest: false,
      overlay:false,
      campodireccion: false,
      campodistrito: false,
      campofecnac: false,
      campofoto: false,
      campoinvitado: false,
      campoizqder: false,
      camporeferido: false,
      camposexo: false,
      campotelefono: false,
      campofumador: false,
      campotipocarnet: false,
      campocondiciones:false,
      camporef1: false,
      camporef2:false,
      condiciones: 'Soy Mayor de Edad',
      labelNombre:'Nombre',
      labelApellidoPaterno:'Apellido paterno',
      labelApellidoMaterno:'Apellido Materno',
      labelDNI:'Numero de Documento',
      labelDistrito: 'Comuna',
      labelTipoDocumento:'Tipo de Documento',
      labelFechaNacimiento: 'Fecha de nacimiento',
      labelEmail:'Correo Electrónico',
      labelSexo:'Género',
      labelRef1:'',
      labelRef2:'',
      titulonegocio:'',
      logoexist: false,
      logoimg : '',
      eventodisenio: {},
      stylePagina: {
        fontColor:'black',
        fontFamily: 'Futura Bk BT',
        color: '#1E3D90',
        backgroundColor:'#FFD101'
      },
      styleComponent:{
        color:'#1E3D90',
        backgroundColor:'#FFD101'
      },
      styleCabecera:{
        color:'#1E3D90',
        backgroundColor:'#FFD101'
      },
ciudadId:0,
      ciudades:[],
      provinciaId:0,
      provincias:[],
      paisId:0,
      styleForm:{
        color:'#1E3D90',
        backgroundColor:'#FFD101',
        marginTop:'0px !important'
      },
      styleMain:{

      },
      btnPag: {
        backgroundColor: '#1E3D90',
        color:'white'
      },
      tag:'',
      referido:'',
      editedItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
telefono:'',
direccion:'',
sexo:{},
tipoDocumento:{},
        ref1:'',
        ref2:'',
      }
    }
  },
  created () {
    this.$vuetify.theme.dark = false
  },

  watch: {
    date () {
      this.editedItem.fechaNacimiento = this.formatDatee(this.date)
    }
  },
  mounted () {
    this.tagevento =  'johnniewalkerblonde';
    this.damedisenio();
    this.damedistritos();
    this.date = moment(this.date).year(moment(this.date).year()-18).locale('es-pe').format("YYYY-MM-DD")
    this.maximafecha = this.date
  },
  methods: {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    scrollToCuerpo(){
      const el = this.$refs.cuerpo2;

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
     verEdad() {
       this.editedItem.fechaNacimiento.replace("/","-")
       let diff = new Date().getUTCFullYear() -  new Date(this.editedItem.fechaNacimiento).getUTCFullYear();

       return diff;

},
    scrollToCabecera(){
      const el = this.$refs.cuerpo;

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    formatDateRe(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    dameprovincias(){
      axios
          .get('provincias/pais/46')
          .then(response => {
            this.provincias = response.data;
            this.dameciudades()

          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameciudades(){
      this.progr = true;
      axios
          .get('ciudades/provincia/33')
          .then(response => {
            this.ciudades = response.data;
            this.damedistritos()
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damedistritos(){
      this.progr = true;
      axios
          .get('distritos/ciudad/203')
          .then(response => {
            this.distritos = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    save(){
      if(this.verEdad()>=18){
        if(this.editedItem.aceptoCondicion && this.aceptotermino ){
          var bodyFormData = new FormData();
          this.overlay = true;
          this.editedItem.fechaNacimiento = this.formatDateRe(this.editedItem.fechaNacimiento)

          if(this.editedItem.fechaNacimiento === "Fecha inválida"){
            this.editedItem.fechaNacimiento = "01-01-1995"
          }
          this.editedItem.tipoDocumento = this.tiposdoc.find(x => x.id === 7)
          bodyFormData.append("persona",JSON.stringify(this.editedItem))
          bodyFormData.append("tagevento",this.tagevento)
          this.rest = true
          axios
              .post('tickets/grabar/formulario/sgs',bodyFormData)
              .then(response => {
                let ticketMin = response.data;
                console.log(ticketMin)
                this.alertnuevo = true
                this.rest = false
                this.overlay = false
              })
              .catch((error)  => {
                console.log(error);
                this.overlay = false
              });
        }else {
          this.error = "Debes Aceptar los Terminos y Condiciones,  y Ser Mayor de Edad";
          this.alerterror = true;
        }
      }else{
        this.error = "Debes Ser Mayor de Edad";
        this.alerterror = true;
      }

    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    damedisenio(){
      axios
          .get('disenio/evento/'+this.tagevento)
          .then(response => {
            this.eventodisenio = response.data;
            console.log(this.eventodisenio);
            this.campoapmaterno= this.eventodisenio.campoapmaterno;
            this.labelApellidoMaterno = this.eventodisenio.labelApmaterno;
            this.labelApellidoPaterno = this.eventodisenio.labelAppaterno;
            this.campotelefono = this.eventodisenio.campotelefono;
            this.campoinvitado = this.eventodisenio.campoinvitado;
            this.camposexo = this.eventodisenio.camposexo;
            this.campodireccion = this.eventodisenio.campodireccion;
            this.campodistrito = this.eventodisenio.campodistrito;
            this.campofecnac  = this.eventodisenio.campofecnac;
            this.campofumador = this.eventodisenio.campofumador;
            this.logoexist = this.eventodisenio.logoCargado;
            this.logoimg = this.eventodisenio.logo;
            this.stylePagina.color = this.eventodisenio.colorText;
            this.btnPag.color = this.eventodisenio.colorTextBotn;
            this.btnPag.backgroundColor = this.eventodisenio.colorBgBoton;
            this.labelRef1 = this.eventodisenio.labelRef1;
            this.labelRef2 = this.eventodisenio.labelRef2;
            this.camporef1 = this.eventodisenio.camporef1;
            this.camporef2 = this.eventodisenio.camporef2;
            this.styleMain.backgroundSize = "cover";
            this.stylePagina.backgroundImage = "url('"+this.eventodisenio.backgroundImage+"')";

            this.styleCabecera.backgroundColor = this.eventodisenio.backCabeceraColor;
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #1E3D90;
}
.theme--light.v-label {
  color: #1E3D90 !important;
}
.v-input .v-label {
  color: #1E3D90 !important;

}

</style>